"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.albertaCities = void 0;
exports.albertaCities = [
    {
        label: "Acme",
        value: 7004,
    },
    {
        label: "Aden",
        value: 7005,
    },
    {
        label: "Aetna",
        value: 7751,
    },
    {
        label: "Airdrie",
        value: 7006,
    },
    {
        label: "Alberta Beach",
        value: 7008,
    },
    {
        label: "Alder Flats",
        value: 7007,
    },
    {
        label: "Alexander, AB",
        value: 7009,
    },
    {
        label: "Alhambra, AB",
        value: 7011,
    },
    {
        label: "Alix",
        value: 7010,
    },
    {
        label: "Alliance",
        value: 7012,
    },
    {
        label: "Amisk",
        value: 7014,
    },
    {
        label: "Andrew",
        value: 7016,
    },
    {
        label: "Anzac",
        value: 7019,
    },
    {
        label: "Ardmore",
        value: 7017,
    },
    {
        label: "Ardrossan",
        value: 7015,
    },
    {
        label: "Argentia Beach",
        value: 7018,
    },
    {
        label: "Arrowwood",
        value: 7020,
    },
    {
        label: "Ashmont",
        value: 7021,
    },
    {
        label: "Athabasca",
        value: 7022,
    },
    {
        label: "Balac",
        value: 7024,
    },
    {
        label: "Balzac",
        value: 7135,
    },
    {
        label: "Banff",
        value: 7023,
    },
    {
        label: "Barnwell",
        value: 7028,
    },
    {
        label: "Barons",
        value: 7030,
    },
    {
        label: "Barrhead",
        value: 7032,
    },
    {
        label: "Barrons",
        value: 7033,
    },
    {
        label: "Bashaw",
        value: 7034,
    },
    {
        label: "Bassano",
        value: 7036,
    },
    {
        label: "Bawlf",
        value: 7038,
    },
    {
        label: "Beaumont",
        value: 7039,
    },
    {
        label: "Beaver Lodge",
        value: 7040,
    },
    {
        label: "Beiseker",
        value: 7042,
    },
    {
        label: "Bellevue",
        value: 7044,
    },
    {
        label: "Bentley",
        value: 7046,
    },
    {
        label: "Bertula Beach",
        value: 7050,
    },
    {
        label: "Berwyn",
        value: 7048,
    },
    {
        label: "Big Valley",
        value: 7052,
    },
    {
        label: "Bitternlake",
        value: 7054,
    },
    {
        label: "Black Diamond",
        value: 7056,
    },
    {
        label: "Blackfalds",
        value: 7058,
    },
    {
        label: "Blackie",
        value: 7060,
    },
    {
        label: "Blacktoct",
        value: 7061,
    },
    {
        label: "Blairmore",
        value: 7062,
    },
    {
        label: "Blufftir",
        value: 7063,
    },
    {
        label: "Bluffton",
        value: 7055,
    },
    {
        label: "Bon Accord",
        value: 7064,
    },
    {
        label: "Bonnyville",
        value: 7066,
    },
    {
        label: "Bonnyville Beach",
        value: 7068,
    },
    {
        label: "Botha",
        value: 7070,
    },
    {
        label: "Bow Island",
        value: 7072,
    },
    {
        label: "Bowden",
        value: 7074,
    },
    {
        label: "Boyle",
        value: 7076,
    },
    {
        label: "Bragg Creek",
        value: 7077,
    },
    {
        label: "Breton",
        value: 7078,
    },
    {
        label: "Brooks",
        value: 7080,
    },
    {
        label: "Bruderheim",
        value: 7082,
    },
    {
        label: "Buck Lake",
        value: 7083,
    },
    {
        label: "Burdett",
        value: 7084,
    },
    {
        label: "Busby",
        value: 7086,
    },
    {
        label: "Calgary",
        value: 7090,
    },
    {
        label: "Calmar",
        value: 7100,
    },
    {
        label: "Camrose",
        value: 7102,
    },
    {
        label: "Canmore",
        value: 7104,
    },
    {
        label: "Carbon",
        value: 7106,
    },
    {
        label: "Carbondale",
        value: 9101,
    },
    {
        label: "Cardiff",
        value: 9100,
    },
    {
        label: "Cardston",
        value: 7108,
    },
    {
        label: "Carmangay",
        value: 7110,
    },
    {
        label: "Caroline",
        value: 7112,
    },
    {
        label: "Carstairs",
        value: 7114,
    },
    {
        label: "Carvel",
        value: 7025,
    },
    {
        label: "Castle Island",
        value: 7116,
    },
    {
        label: "Castor",
        value: 7118,
    },
    {
        label: "Cayley",
        value: 7120,
    },
    {
        label: "Cereal",
        value: 7122,
    },
    {
        label: "Cessford",
        value: 7123,
    },
    {
        label: "Champion",
        value: 7124,
    },
    {
        label: "Chateh",
        value: 7103,
    },
    {
        label: "Chauvin",
        value: 7126,
    },
    {
        label: "Cherhill",
        value: 7125,
    },
    {
        label: "Chestermere",
        value: 7752,
    },
    {
        label: "Chief Mountain",
        value: 7129,
    },
    {
        label: "Chinook",
        value: 7127,
    },
    {
        label: "Chipman, AB",
        value: 7128,
    },
    {
        label: "Clairmont, AB",
        value: 7131,
    },
    {
        label: "Claresholm",
        value: 7130,
    },
    {
        label: "Clive",
        value: 7132,
    },
    {
        label: "Cluny",
        value: 7134,
    },
    {
        label: "Clyde",
        value: 7136,
    },
    {
        label: "Coaldale",
        value: 7398,
    },
    {
        label: "Coalhurst",
        value: 7137,
    },
    {
        label: "Cochrane, AB",
        value: 7138,
    },
    {
        label: "Cold Lake",
        value: 7140,
    },
    {
        label: "Coleman",
        value: 7142,
    },
    {
        label: "College Heights",
        value: 7143,
    },
    {
        label: "Consort",
        value: 7144,
    },
    {
        label: "Coronation",
        value: 7146,
    },
    {
        label: "Coutts",
        value: 7148,
    },
    {
        label: "Cowley",
        value: 7150,
    },
    {
        label: "Craigmyle",
        value: 7152,
    },
    {
        label: "Cremona",
        value: 7154,
    },
    {
        label: "Crossfield",
        value: 7156,
    },
    {
        label: "Crystal Srpings",
        value: 7158,
    },
    {
        label: "Czar",
        value: 7159,
    },
    {
        label: "Daysland",
        value: 7160,
    },
    {
        label: "De Winton",
        value: 7169,
    },
    {
        label: "Debolt",
        value: 7026,
    },
    {
        label: "Del Bonita Falls",
        value: 7161,
    },
    {
        label: "Delacour",
        value: 7027,
    },
    {
        label: "Delburne",
        value: 7162,
    },
    {
        label: "Delia",
        value: 7164,
    },
    {
        label: "Derwent",
        value: 7166,
    },
    {
        label: "Devon",
        value: 7200,
    },
    {
        label: "Dewberry",
        value: 7170,
    },
    {
        label: "Diamond City",
        value: 7171,
    },
    {
        label: "Didsbury",
        value: 7172,
    },
    {
        label: "Donalda",
        value: 7174,
    },
    {
        label: "Donnelly",
        value: 7176,
    },
    {
        label: "Drayton Valley",
        value: 7178,
    },
    {
        label: "Drumheller",
        value: 7180,
    },
    {
        label: "Duchess",
        value: 7182,
    },
    {
        label: "Dunmore",
        value: 7139,
    },
    {
        label: "Eaglesham",
        value: 7190,
    },
    {
        label: "Eckville",
        value: 7192,
    },
    {
        label: "Edberg",
        value: 7194,
    },
    {
        label: "Edgerton",
        value: 7196,
    },
    {
        label: "Edmonton",
        value: 7198,
    },
    {
        label: "Edmonton Beach",
        value: 7204,
    },
    {
        label: "Edson",
        value: 7222,
    },
    {
        label: "Elk Point",
        value: 7224,
    },
    {
        label: "Elnora",
        value: 7226,
    },
    {
        label: "Empress",
        value: 7228,
    },
    {
        label: "Enchant",
        value: 7229,
    },
    {
        label: "Entwistle",
        value: 7230,
    },
    {
        label: "Erskine",
        value: 7029,
    },
    {
        label: "Evansburg",
        value: 7232,
    },
    {
        label: "Fairview",
        value: 7234,
    },
    {
        label: "Falher",
        value: 7236,
    },
    {
        label: "Faust",
        value: 7205,
    },
    {
        label: "Ferintosh",
        value: 7238,
    },
    {
        label: "Foremost",
        value: 7240,
    },
    {
        label: "Forest Lawn",
        value: 7243,
    },
    {
        label: "Forestburg",
        value: 7242,
    },
    {
        label: "Fort Assiniboine",
        value: 7244,
    },
    {
        label: "Fort Chipewyan",
        value: 7245,
    },
    {
        label: "Fort Macleod",
        value: 7246,
    },
    {
        label: "Fort Mcmurray",
        value: 7248,
    },
    {
        label: "Fort Saskatchewan",
        value: 7206,
    },
    {
        label: "Fort Vermillion",
        value: 7207,
    },
    {
        label: "Fox Creek",
        value: 7252,
    },
    {
        label: "Frank",
        value: 7254,
    },
    {
        label: "Gadsby",
        value: 7260,
    },
    {
        label: "Galahad",
        value: 7262,
    },
    {
        label: "Ghost Lake",
        value: 7264,
    },
    {
        label: "Gibbons, AB",
        value: 7266,
    },
    {
        label: "Giroux",
        value: 7267,
    },
    {
        label: "Girouxville, AB",
        value: 7268,
    },
    {
        label: "Gleichen",
        value: 7270,
    },
    {
        label: "Glendon",
        value: 7272,
    },
    {
        label: "Glenevis",
        value: 7209,
    },
    {
        label: "Glenwood, AB",
        value: 7274,
    },
    {
        label: "Golden Days",
        value: 7276,
    },
    {
        label: "Good Fish Lake",
        value: 7277,
    },
    {
        label: "Goodfare",
        value: 7035,
    },
    {
        label: "Grand Centre",
        value: 7278,
    },
    {
        label: "Grande Cache",
        value: 7280,
    },
    {
        label: "Grande Prairie",
        value: 7282,
    },
    {
        label: "Grandview, AB",
        value: 7284,
    },
    {
        label: "Granum",
        value: 7286,
    },
    {
        label: "Grassland",
        value: 7287,
    },
    {
        label: "Grassy Lake",
        value: 7288,
    },
    {
        label: "Grimshaw",
        value: 7290,
    },
    {
        label: "Gull Lake, AB",
        value: 7292,
    },
    {
        label: "Hairy Hill",
        value: 7300,
    },
    {
        label: "Halkirk",
        value: 7302,
    },
    {
        label: "Hanna",
        value: 7304,
    },
    {
        label: "Hardisty",
        value: 7306,
    },
    {
        label: "Hay Lakes",
        value: 7308,
    },
    {
        label: "Hays",
        value: 7307,
    },
    {
        label: "Hayter",
        value: 7309,
    },
    {
        label: "Heisler",
        value: 7310,
    },
    {
        label: "High Level",
        value: 7312,
    },
    {
        label: "High Prairie",
        value: 7314,
    },
    {
        label: "High River",
        value: 7316,
    },
    {
        label: "Hilda",
        value: 7317,
    },
    {
        label: "Hill Spring",
        value: 7318,
    },
    {
        label: "Hilliard",
        value: 7031,
    },
    {
        label: "Hines Creek",
        value: 7319,
    },
    {
        label: "Hinton",
        value: 7320,
    },
    {
        label: "Hobbema",
        value: 7321,
    },
    {
        label: "Holden",
        value: 7322,
    },
    {
        label: "Hughenden",
        value: 7324,
    },
    {
        label: "Huies Creek",
        value: 7326,
    },
    {
        label: "Hussar",
        value: 7328,
    },
    {
        label: "Hythe",
        value: 7330,
    },
    {
        label: "Innisfail",
        value: 7340,
    },
    {
        label: "Innisfield",
        value: 7753,
    },
    {
        label: "Innisfree",
        value: 7342,
    },
    {
        label: "Irma",
        value: 7344,
    },
    {
        label: "Iron River",
        value: 7347,
    },
    {
        label: "Iron Springs",
        value: 7037,
    },
    {
        label: "Irricana",
        value: 7346,
    },
    {
        label: "Irvine",
        value: 7348,
    },
    {
        label: "Island Lake, AB",
        value: 7350,
    },
    {
        label: "Itaska Beach",
        value: 7352,
    },
    {
        label: "Janvier",
        value: 7211,
    },
    {
        label: "Jasper",
        value: 7356,
    },
    {
        label: "Kapasiwin",
        value: 7360,
    },
    {
        label: "Keoma",
        value: 7515,
    },
    {
        label: "Killam",
        value: 7362,
    },
    {
        label: "Kinuso",
        value: 7364,
    },
    {
        label: "Kipp",
        value: 7365,
    },
    {
        label: "Kitscoty",
        value: 7366,
    },
    {
        label: "La CrÃªte",
        value: 7141,
    },
    {
        label: "La Glace",
        value: 7145,
    },
    {
        label: "Lac la Biche",
        value: 7380,
    },
    {
        label: "Lacombe",
        value: 7382,
    },
    {
        label: "Lake Louise",
        value: 7383,
    },
    {
        label: "Lakeview",
        value: 7384,
    },
    {
        label: "Lamont",
        value: 7386,
    },
    {
        label: "Langdon",
        value: 7013,
    },
    {
        label: "Lavoy",
        value: 7390,
    },
    {
        label: "Leduc",
        value: 7208,
    },
    {
        label: "Legal",
        value: 7394,
    },
    {
        label: "Leslieville",
        value: 7395,
    },
    {
        label: "Lethbridge",
        value: 7396,
    },
    {
        label: "Linden",
        value: 7408,
    },
    {
        label: "Little Smoky",
        value: 7409,
    },
    {
        label: "Lloydminster, AB",
        value: 7410,
    },
    {
        label: "Lodgepole",
        value: 7411,
    },
    {
        label: "Lomond",
        value: 7412,
    },
    {
        label: "Longview",
        value: 7414,
    },
    {
        label: "Lougheed",
        value: 7416,
    },
    {
        label: "Ma Me O Beach",
        value: 7420,
    },
    {
        label: "Magrath",
        value: 7422,
    },
    {
        label: "Mallaig",
        value: 7153,
    },
    {
        label: "Manning",
        value: 7426,
    },
    {
        label: "Mannville",
        value: 7428,
    },
    {
        label: "Markerville",
        value: 7429,
    },
    {
        label: "Marsden",
        value: 7430,
    },
    {
        label: "Marwayne",
        value: 7434,
    },
    {
        label: "Mayerthorpe",
        value: 7436,
    },
    {
        label: "McLennan",
        value: 7438,
    },
    {
        label: "Medicine Hat",
        value: 7440,
    },
    {
        label: "Medley",
        value: 7441,
    },
    {
        label: "Meeting Creek",
        value: 7443,
    },
    {
        label: "Midnapore",
        value: 7448,
    },
    {
        label: "Milk River",
        value: 7450,
    },
    {
        label: "Millarville",
        value: 7041,
    },
    {
        label: "Millet",
        value: 7452,
    },
    {
        label: "Milo",
        value: 7454,
    },
    {
        label: "Minburn",
        value: 7456,
    },
    {
        label: "Mirror",
        value: 7458,
    },
    {
        label: "Monarch",
        value: 7459,
    },
    {
        label: "Morinville",
        value: 7460,
    },
    {
        label: "Morrin",
        value: 7462,
    },
    {
        label: "Mundare",
        value: 7464,
    },
    {
        label: "Munson",
        value: 7466,
    },
    {
        label: "Musidora",
        value: 7043,
    },
    {
        label: "Myrnam",
        value: 7468,
    },
    {
        label: "Nakamun Park",
        value: 7480,
    },
    {
        label: "Nampa",
        value: 7482,
    },
    {
        label: "Nanton",
        value: 7484,
    },
    {
        label: "Neerlandia",
        value: 7485,
    },
    {
        label: "New Dayton",
        value: 7487,
    },
    {
        label: "New Norway",
        value: 7488,
    },
    {
        label: "New Sarepta",
        value: 7490,
    },
    {
        label: "Nisku",
        value: 7491,
    },
    {
        label: "Nito Junction",
        value: 7495,
    },
    {
        label: "Nobleford",
        value: 7492,
    },
    {
        label: "Nordegg",
        value: 7147,
    },
    {
        label: "Norglenwood",
        value: 7494,
    },
    {
        label: "North Star",
        value: 7045,
    },
    {
        label: "Nythe",
        value: 7496,
    },
    {
        label: "Okotoks",
        value: 7094,
    },
    {
        label: "Olds",
        value: 7502,
    },
    {
        label: "Onoway",
        value: 7504,
    },
    {
        label: "Other",
        value: 7999,
    },
    {
        label: "Oyen",
        value: 7506,
    },
    {
        label: "Paradise Valley",
        value: 7512,
    },
    {
        label: "Patricia",
        value: 7513,
    },
    {
        label: "Peace River",
        value: 7514,
    },
    {
        label: "Peers",
        value: 7361,
    },
    {
        label: "Penhold",
        value: 7516,
    },
    {
        label: "Pickard Ville",
        value: 7517,
    },
    {
        label: "Picture Butte",
        value: 7518,
    },
    {
        label: "Pincher Creek",
        value: 7520,
    },
    {
        label: "Plamondon",
        value: 7522,
    },
    {
        label: "Point Alison",
        value: 7524,
    },
    {
        label: "Ponoka",
        value: 7526,
    },
    {
        label: "Poplar Bay",
        value: 7528,
    },
    {
        label: "Priddis",
        value: 7529,
    },
    {
        label: "Prosperity",
        value: 7532,
    },
    {
        label: "Provost",
        value: 7530,
    },
    {
        label: "Purple Springs",
        value: 7536,
    },
    {
        label: "Radway",
        value: 7540,
    },
    {
        label: "Rainbow Lake",
        value: 7542,
    },
    {
        label: "Rainier",
        value: 7543,
    },
    {
        label: "Ralston",
        value: 7151,
    },
    {
        label: "Raymond",
        value: 7544,
    },
    {
        label: "Red Deer",
        value: 7546,
    },
    {
        label: "Red Deer County",
        value: 7047,
    },
    {
        label: "Red Earth Creek",
        value: 7213,
    },
    {
        label: "Redcliff",
        value: 7442,
    },
    {
        label: "Redwater",
        value: 7550,
    },
    {
        label: "Redwood Meadows",
        value: 7049,
    },
    {
        label: "Rimbey",
        value: 7552,
    },
    {
        label: "Rochester",
        value: 7553,
    },
    {
        label: "Rochfort Bridge",
        value: 7555,
    },
    {
        label: "Rochon Sands",
        value: 7554,
    },
    {
        label: "Rocky Mountain Ho",
        value: 7556,
    },
    {
        label: "Rocky View",
        value: 7096,
    },
    {
        label: "Rockyford",
        value: 7560,
    },
    {
        label: "Rolling Hills",
        value: 7561,
    },
    {
        label: "Rosalind",
        value: 7562,
    },
    {
        label: "Rosedale Station",
        value: 7149,
    },
    {
        label: "Rosemary",
        value: 7564,
    },
    {
        label: "Ross Haven",
        value: 7566,
    },
    {
        label: "Rumsey",
        value: 7568,
    },
    {
        label: "Rycroft",
        value: 7570,
    },
    {
        label: "Ryley",
        value: 7572,
    },
    {
        label: "Saint-Isidore",
        value: 7597,
    },
    {
        label: "Saint-Lina",
        value: 7599,
    },
    {
        label: "Saint-Michael",
        value: 7601,
    },
    {
        label: "Sandy Beach, AB",
        value: 7580,
    },
    {
        label: "Sanguda Silver Sa",
        value: 7582,
    },
    {
        label: "Scandia",
        value: 7583,
    },
    {
        label: "Seba Beach",
        value: 7584,
    },
    {
        label: "Sedgewick",
        value: 7586,
    },
    {
        label: "Sexsmith",
        value: 7588,
    },
    {
        label: "Shaughnessy",
        value: 7589,
    },
    {
        label: "Sherwood Park, AB",
        value: 7210,
    },
    {
        label: "Siksika",
        value: 7215,
    },
    {
        label: "Silver Beach",
        value: 7590,
    },
    {
        label: "Slave Lake",
        value: 7592,
    },
    {
        label: "Smoky Lake",
        value: 7594,
    },
    {
        label: "South View",
        value: 7596,
    },
    {
        label: "Spirit River",
        value: 7598,
    },
    {
        label: "Spring Lake",
        value: 7051,
    },
    {
        label: "Spruce Grove",
        value: 7212,
    },
    {
        label: "Spruceview",
        value: 7603,
    },
    {
        label: "St Albert",
        value: 7214,
    },
    {
        label: "St. Paul",
        value: 7600,
    },
    {
        label: "St-Albert Falls",
        value: 7595,
    },
    {
        label: "Standard",
        value: 7604,
    },
    {
        label: "Stavely",
        value: 7606,
    },
    {
        label: "Stettler",
        value: 7608,
    },
    {
        label: "Stirling, AB",
        value: 7610,
    },
    {
        label: "Stony Plain",
        value: 7216,
    },
    {
        label: "Strathcona",
        value: 7218,
    },
    {
        label: "Strathmore",
        value: 7616,
    },
    {
        label: "Strome",
        value: 7618,
    },
    {
        label: "Sturgeon",
        value: 7619,
    },
    {
        label: "Suffield",
        value: 7621,
    },
    {
        label: "Sundance Beach",
        value: 7620,
    },
    {
        label: "Sundre",
        value: 7622,
    },
    {
        label: "Sunset House",
        value: 7623,
    },
    {
        label: "Sunset Point",
        value: 7624,
    },
    {
        label: "Swan Hills",
        value: 7626,
    },
    {
        label: "Sylvan Lake",
        value: 7628,
    },
    {
        label: "Taber",
        value: 7640,
    },
    {
        label: "Tangent",
        value: 7754,
    },
    {
        label: "Thorhild",
        value: 7642,
    },
    {
        label: "Thorsby",
        value: 7644,
    },
    {
        label: "Three Hills",
        value: 7646,
    },
    {
        label: "Tilley",
        value: 7648,
    },
    {
        label: "Tofield",
        value: 7650,
    },
    {
        label: "Tomahaw",
        value: 7651,
    },
    {
        label: "Torrington",
        value: 7652,
    },
    {
        label: "Trochu",
        value: 7654,
    },
    {
        label: "Turin",
        value: 7655,
    },
    {
        label: "Turner Valley",
        value: 7656,
    },
    {
        label: "Two Hills",
        value: 7658,
    },
    {
        label: "Val Quentin",
        value: 7670,
    },
    {
        label: "Valleyview",
        value: 7672,
    },
    {
        label: "Vauxhall",
        value: 7674,
    },
    {
        label: "Vegreville",
        value: 7676,
    },
    {
        label: "Vermillion",
        value: 7678,
    },
    {
        label: "Veteran",
        value: 7680,
    },
    {
        label: "Viking",
        value: 7682,
    },
    {
        label: "Vilna",
        value: 7684,
    },
    {
        label: "Vimy",
        value: 7053,
    },
    {
        label: "Vulcan",
        value: 7686,
    },
    {
        label: "Wabamun",
        value: 7688,
    },
    {
        label: "Wabas-Desmar",
        value: 7689,
    },
    {
        label: "Wainwright",
        value: 7690,
    },
    {
        label: "Wanham",
        value: 7692,
    },
    {
        label: "Warburg",
        value: 7694,
    },
    {
        label: "Warner",
        value: 7696,
    },
    {
        label: "Warspite",
        value: 7698,
    },
    {
        label: "Wasca",
        value: 7700,
    },
    {
        label: "Waskatenau",
        value: 7702,
    },
    {
        label: "Water Valley",
        value: 7057,
    },
    {
        label: "Waterton",
        value: 7699,
    },
    {
        label: "Waterton Lakes",
        value: 7701,
    },
    {
        label: "Watino",
        value: 7703,
    },
    {
        label: "Welling",
        value: 7059,
    },
    {
        label: "Wembly",
        value: 7704,
    },
    {
        label: "West Cove",
        value: 7706,
    },
    {
        label: "Westerose",
        value: 7065,
    },
    {
        label: "Westlock",
        value: 7708,
    },
    {
        label: "Wetaskiwin",
        value: 7710,
    },
    {
        label: "Whitecourt",
        value: 7712,
    },
    {
        label: "Whitelaw",
        value: 7755,
    },
    {
        label: "Wild Horse",
        value: 7713,
    },
    {
        label: "Wildwood",
        value: 7714,
    },
    {
        label: "Willingdon",
        value: 7716,
    },
    {
        label: "Winfield, AB",
        value: 7718,
    },
    {
        label: "Winterburn",
        value: 7720,
    },
    {
        label: "Woking",
        value: 7725,
    },
    {
        label: "Yellowstone",
        value: 7730,
    },
    {
        label: "Youngstown",
        value: 7732,
    },
    {
        label: "Zama",
        value: 7750,
    },
];
